import {React, useHistory} from 'external/react'
import {
  Tabs,
  Tab,
  styled
}
from 'external/material'
import {a11yProps} from '../components/TabPanel'

const QuizTab = styled(Tab)(quizTabStyles)
const QuizTabs = styled(Tabs)(quizTabsStyles)
const StyledQuizTab = styled('div')(tabsComponentStyles)

const QuizTabsComponent = ({context}) => {

  const {translate, link, tab, updateState} = context
  const history = useHistory()

  const handleChange = async (event, nextTab) => {
    if (nextTab === tab) return
    await updateState({
      quizStandardFilters: {
        expectations: {$set: []},
        indicators: {$set: []},
        standards: {$set: []}
      }
    })
    history.push(link({tab: nextTab}, '/:languageId/:role/:page/:tab'))
  }

  return (
    <StyledQuizTab>
      {tab && (
        <QuizTabs value={tab} onChange={handleChange} aria-label="ant example">
          <QuizTab value="assessments" label={translate('assessment-tab')} {...a11yProps('assessments')} />
          <QuizTab value="question-bank" label={translate('question-bank-tab')} {...a11yProps('question-bank')} />)
          <QuizTab value="assessment-bank" label={translate('assessment-bank-tab')} {...a11yProps('assessment-bank')} />
          <QuizTab value="assigned" label={translate('assigned-assessment-tab')} {...a11yProps('assigned')} />
        </QuizTabs>
      )}
    </StyledQuizTab>
  )
}

export {QuizTabsComponent as default}

function tabsComponentStyles () {
  return {
    flexGrow: 1
  }
}

function quizTabStyles({theme}) { 
  return {
      textTransform: 'none',
      minWidth: 72,
      color: '#929cb5',
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      textTransform: 'uppercase',
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#4f576e',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#4f576e',
      },
    }
}

function quizTabsStyles() {
  return {
    borderBottom: '1px solid #e8e8e8',
    '& .indicator': {
      height: 4,
      backgroundColor: '#f3a608',
    }
  }
}
